import type { DemoKey } from '../types';

export const gu: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'ગણિત · આંકડાશાસ્ત્ર',
  'app.title': 'આંકડાશાસ્ત્ર',
  'panel.experiment': 'દૃશ્ય',
  'panel.params': 'પેરામીટર',

  'exp.survey-explorer.title': 'સર્વેક્ષણ એક્સપ્લોરર',
  'exp.survey-explorer.desc': 'કૉલમ પસંદ કરો; ડેમો યોગ્ય સારાંશ પસંદ કરે છે.',
  'exp.distribution-sculptor.title': 'વિતરણ શિલ્પી',
  'exp.distribution-sculptor.desc': 'બિંદુ ખેંચો અને આંકડાનો પ્રતિસાદ જુઓ.',
  'exp.two-variable-lab.title': 'દ્વિ-ચલ પ્રયોગશાળા',
  'exp.two-variable-lab.desc': 'સ્કેટર, ફિટ અને કારણ વિશે પ્રશ્ન.',
  'exp.sampling-lab.title': 'નમૂના પ્રયોગશાળા',
  'exp.sampling-lab.desc': 'કેવી રીતે તકનીક અને કદ નમૂના સરેરાશને ખસેડે છે.',
  'exp.probability-diagrams.title': 'સંભાવ્યતા આકૃતિ',
  'exp.probability-diagrams.desc': 'સંયુક્ત ઘટના માટે વેન અને ઝાડ.',

  'type.qualitative-nominal.label': 'ગુણાત્મક · નામિક',
  'type.qualitative-nominal.def': 'કુદરતી ક્રમ વગરની શ્રેણીઓ.',
  'type.qualitative-ordinal.label': 'ગુણાત્મક · ક્રમિક',
  'type.qualitative-ordinal.def': 'અર્થપૂર્ણ ક્રમ સાથેની શ્રેણીઓ.',
  'type.qualitative-multi.label': 'ગુણાત્મક · બહુ-મૂલ્ય',
  'type.qualitative-multi.def': 'દરેક અવલોકન પર અનેક ટૅગ.',
  'type.quantitative-discrete.label': 'સંખ્યાત્મક · છૂટક',
  'type.quantitative-discrete.def': 'નિશ્ચિત પગથિયામાં અંકો.',
  'type.quantitative-continuous.label': 'સંખ્યાત્મક · સતત',
  'type.quantitative-continuous.def': 'સતત માપદંડ પર અંકો.',

  'column.name.label': 'વિદ્યાર્થી નામ',
  'column.height_cm.label': 'ઊંચાઈ',
  'column.shoe_size_eu.label': 'જૂતા સાઇઝ (EU)',
  'column.study_hours.label': 'અભ્યાસ કલાક / અઠવાડિયું',
  'column.test_score.label': 'પરીક્ષા ગુણ',
  'column.sports_played.label': 'રમતો',
  'column.eye_color.label': 'આંખનો રંગ',
  'column.commute_min.label': 'મુસાફરી',
  'column.grade_year.label': 'ધોરણ',
  'column.homework_effort.label': 'ગૃહકાર્ય મહેનત',
  'column.ice-cream-sales.label': 'આઇસક્રીમ વેચાણ',
  'column.drownings.label': 'ડૂબવાની ઘટના',
  'column.month.label': 'મહિનો',
  'column.storks.label': 'સારસ',
  'column.births.label': 'જન્મ',
  'column.country_area_km2.label': 'દેશનું ક્ષેત્રફળ',
  'column.sleep_hours.label': 'ઊંઘ કલાક',
  'column.reaction_ms.label': 'પ્રતિક્રિયા સમય',

  'dataset.master-survey.label': 'વર્ગ સર્વેક્ષણ',
  'dataset.master-survey.desc': '30 સિમ્યુલેટેડ વિદ્યાર્થી.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'આઇસક્રીમ વેચાણ વિ. ડૂબવું',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'બંને ઋતુ સાથે ઊંચા-નીચા થાય. ડૂબવાથી આઇસક્રીમ વેચાણ થતું નથી.',
  'dataset.spurious-storks-vs-births.label': 'સારસ વિ. જન્મ',
  'dataset.spurious-storks-vs-births.desc': 'મોટા દેશોમાં વધુ સારસ અને વધુ જન્મ. પક્ષી કારણ નથી.',
  'dataset.real-sleep-vs-reaction-time.label': 'ઊંઘ વિ. પ્રતિક્રિયા સમય',
  'dataset.real-sleep-vs-reaction-time.desc':
    'વધુ ઊંઘ, ઝડપી પ્રતિક્રિયા. વાસ્તવિક ઋણ સંબંધ — પ્રતીતિજનક કારણ સહિત.',

  'tag.football.label': 'ફૂટબોલ',
  'tag.basketball.label': 'બાસ્કેટબોલ',
  'tag.volleyball.label': 'વોલીબોલ',
  'tag.swimming.label': 'તરણ',
  'tag.none.label': 'કોઈ નહીં',

  'population.gaussian.label': 'ઘંટ વક્ર',
  'population.right-skewed.label': 'જમણી તરફ ઢળેલ',
  'population.bimodal.label': 'દ્વિશિખર',
  'population.uniform.label': 'સમ',

  'venn.dice-even-or-prime.label': 'પાસો: જોડ કે મૂળ',
  'venn.class-sports-2set.label': 'રમતો (2 સમૂહ)',
  'venn.class-sports-3set.label': 'રમતો (3 સમૂહ)',
  'venn.custom.label': 'કસ્ટમ',

  'tree.draw-without-replacement.label': 'પાછા મૂક્યા વગર',
  'tree.custom.label': 'કસ્ટમ',
  'tree.coin.heads': 'ચ',
  'tree.coin.tails': 'કા',
  'tree.draw.start': 'થેલી: 2 લાલ, 3 ભૂરી',
  'tree.draw.red': 'લાલ',
  'tree.draw.blue': 'ભૂરો',
  'tree.custom.start': 'શરૂ',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'હિસ્ટોગ્રામ',
  'card.cumulative': 'સંચયી આવૃત્તિ',
  'card.box': 'બોક્સ પ્લોટ',
  'card.summary': '5-આંક સારાંશ',
  'card.bar': 'બાર ચાર્ટ',
  'card.mode': 'બહુલક',
  'card.tag-frequency': 'ટૅગ આવૃત્તિ',
  'card.mode-tag': 'શિખર ટૅગ',
  'card.empty-no-order': 'લાગુ નથી',
  'card.empty-multi': 'લાગુ નથી',
  'card.numberline': 'સંખ્યા રેખા',
  'card.scatter': 'સ્કેટર',
  'card.description': 'શું બની રહ્યું',
  'card.population': 'જનસંખ્યા',
  'card.sampling-distribution': 'નમૂના સરેરાશ',
  'card.venn': 'વેન',
  'card.tree': 'ઝાડ',
  'card.probabilities': 'સંભાવ્યતા',

  'param.dataset.label': 'ડેટાસેટ',
  'param.column.label': 'કૉલમ',
  'param.bins.label': 'બિન',
  'param.shape.label': 'પ્રારંભિક આકાર',
  'param.show-mean.label': 'સરેરાશ બતાવો',
  'param.show-median.label': 'મધ્યક બતાવો',
  'param.x-col.label': 'X કૉલમ',
  'param.y-col.label': 'Y કૉલમ',
  'param.show-regression.label': 'રીગ્રેશન રેખા',
  'param.show-residuals.label': 'અવશેષ',
  'param.show-confounder.label': 'મિશ્ર ચલ બતાવો',
  'param.population.label': 'જનસંખ્યા',
  'param.technique.label': 'તકનીક',
  'param.sample-size.label': 'નમૂના કદ',
  'param.stratum.label': 'સ્તર',
  'param.bias.label': 'પક્ષપાત',
  'param.mode.label': 'મોડ',
  'param.preset.label': 'પ્રીસેટ',
  'param.universe.label': 'સંયુક્ત કદ',
  'param.show-prob.label': 'સંભાવ્યતા બતાવો',
  'param.treat-as-numeric.label': 'સંખ્યાત્મક ગણો',

  'stat.count': 'ગણતરી',
  'stat.mean': 'સરેરાશ',
  'stat.median': 'મધ્યક',
  'stat.range': 'પરિસર',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'વિચલિત',
  'stat.r': 'પીયર્સન r',
  'stat.r2': 'r²',
  'stat.slope': 'ઢાળ',
  'stat.intercept': 'આંતરછેદ',
  'stat.n': 'n',
  'stat.population-mean': 'સાચી સરેરાશ',
  'stat.latest-sample-mean': 'નમૂના સરેરાશ',
  'stat.sample-mean-spread': 'નમૂના સરેરાશ SD',
  'stat.sample-count': 'લીધેલા નમૂના',
  'outlier.upper': 'ઉપરના વિચલિત',
  'outlier.lower': 'નીચેના વિચલિત',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'ફરી નમૂના',
  'btn.run-100': '100 નમૂના લો',
  'btn.stop': 'રોકો',
  'btn.clear-history': 'ઇતિહાસ સાફ',

  'explainer.no-order': 'ક્રમ નથી → સંચયી નહીં, બોક્સ નહીં.',
  'explainer.multi-no-iqr': 'બહુ-મૂલ્ય → ચતુર્થાંશ / IQR વ્યાખ્યાયિત નથી.',
  'message.no-data': 'કોઈ ડેટા નથી.',
  'message.needs-quartiles': 'ચતુર્થાંશ માટે ≥4 બિંદુ જરૂરી.',
  'message.x-zero-variance': 'X વેરિયન્સ શૂન્ય — રેખા ફિટ ન થાય.',
  'message.n-too-small': 'n ઘણું નાનું.',
  'message.stratum-clamp': 'સ્તરમાં માગ્યા કરતાં ઓછી હરોળ — બધી વાપરી.',
  'message.siblings-sum-to-one': 'ભાઈ-બહેનનો સરવાળો 1 હોવો જોઈએ.',
};
